CheckItemList = undefined
LimitMixin = require 'lib/limit-mixin'
mixin = require 'lib/mixin'
queueRequire -> CheckItemList = require 'models/collections/check-item-list'
TrelloModel = require 'models/internal/trello-model'
Util = require 'lib/util'

module.exports = class Checklist extends TrelloModel
  mixin LimitMixin, @
  typeName: 'Checklist'
  urlRoot: ->
    '/1/checklists'

  @lazy
    checkItemList: ->
      new CheckItemList().syncSubModels(@, 'checkItems')

  sync: (method, model, options) ->
    if method == 'create' && !(@get('idBoard')? && @get('idCard')?)
      @waitForAttrs @, ['idBoard', 'idCard'], (attrs) =>
        @set(attrs)
        super(method, model, options)

      @waitForId @getBoard(), (id) => @set('idBoard', id)
      @waitForId @getCard(), (id) => @set('idCard', id)
    else
      super

  getCard: ->
    @modelCache.get('Card', @get('idCard')) ? @collection.sourceModel

  getBoard: ->
    @getCard()?.getBoard()

  getCompletedCount: (card) ->
    count = 0

    @checkItemList.each (checkItem) ->
      if checkItem.get('state')?
        count++ if (checkItem.get('state') == 'complete')

    count

  getCheckItem: (idCheckItem) -> @checkItemList.get(idCheckItem)

  editable: -> @getBoard().editable()

  calcPos: (index, checkItem) ->
    Util.calcPos(index, @checkItemList, checkItem)



// WEBPACK FOOTER //
// ./app/scripts/models/checklist.coffee